import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./CustomTooltip.scss";
import classNames from "classnames";


export const CustomTooltip = ({children, text, customClass = "", red = false,
  key= null, hidden = false, placement = "top"}) => {
  const { t } = useTranslation();

  const renderTooltip = (props) => {
    const postionClass = placement === "right" 
      ? "tooltip-right" 
      : placement === "left" 
        ? "tooltip-left" 
        : placement === "bottom" 
          ? "tooltip-bottom"
          : "";

    return (
      hidden
      ? <></>
      : <Tooltip 
          id="tooltip" 
          className={classNames("cust-tooltip", postionClass, customClass, {"tooltip-red": red})} 
          {...props}
        >
          { t(text) }
        </Tooltip>
  )};

  return (
    <OverlayTrigger placement={placement} overlay={renderTooltip} key={key}>
      { children }
    </OverlayTrigger>
  );
};

